import React from 'react';
import PropTypes from 'prop-types';
import MosDatepicker from '@mos-cat/datepicker';
import { DATE_REGEX } from '../../helpers/date';

const Datepicker = ({
  dateFieldData,
  name: dateFieldName,
  onChange,
  saveDraft,
  ...props
}) => {
  const handleChange = ev => {
    const { value, type, name } = ev.target;
    const payload = {
      type: ev.type,
      target: { value, type, name }
    };

    if (value.match(DATE_REGEX)) {
      // eslint-disable-next-line no-param-reassign
      payload.target.value = new Date(value).toLocaleDateString('ru-RU');
    }

    onChange(payload);
    saveDraft();
  };

  let { value } = dateFieldData;

  if (value.match(DATE_REGEX)) {
    value = new Date(value).toLocaleDateString('ru-RU');
  }

  const maxDate = new Date();
  maxDate.setHours(23, 59, 59, 999);

  return (
    <MosDatepicker
      {...props}
      value={value}
      error={dateFieldData.error}
      disabled={dateFieldData.disabled}
      name={dateFieldName}
      onChange={handleChange}
      onBlur={handleChange}
      maxDate={maxDate}
    />
  );
};

Datepicker.propTypes = {
  dateFieldData: PropTypes.shape({
    value: PropTypes.string,
    error: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    disabled: PropTypes.bool
  }).isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  saveDraft: PropTypes.func.isRequired
};

export default Datepicker;
